import * as React from "react";
import Snackbar from "@mui/material/Snackbar";

export default function SimpleSnackbar({ open, setOpen, message }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      message={message}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    />
  );
}
